import { useEffect, useState } from "react";
import { api, formatApiError } from "../../lib/api";
import { toast } from "sonner";
import { useLeague } from "./LeagueLayout";
import { ScrollText } from "lucide-react";

export default function LeagueLog() {
  const { league } = useLeague();
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try { const r = await api.get(`/leagues/${league.league_id}/logs`); setLogs(r.data); }
      catch (e) { toast.error(formatApiError(e)); }
      finally { setLoading(false); }
    })();
  }, [league.league_id]);

  const emojiFor = (action) => {
    if (action.startsWith("op_")) return "💼";
    if (action.includes("league")) return "🏆";
    if (action.includes("team")) return "⚽";
    if (action.includes("player")) return "👤";
    if (action.includes("import")) return "📥";
    if (action.includes("renewal")) return "🔄";
    if (action.includes("season_closed")) return "🎬";
    if (action.includes("stadium")) return "🏛️";
    return "•";
  };

  return (
    <div className="space-y-4">
      <div>
        <div className="text-xs tracking-[0.3em] text-amber-400 uppercase font-bold">📜 Log operazioni</div>
        <h2 className="text-3xl font-black tracking-tight">Audit trail</h2>
        <p className="text-slate-400 text-sm mt-1">Registro permanente di tutte le azioni. Non modificabile.</p>
      </div>

      {loading ? <div className="text-slate-500 py-10 text-center">Caricamento…</div> :
      logs.length === 0 ? (
        <div className="border border-dashed border-slate-800 rounded-lg p-10 text-center text-slate-500" data-testid="log-empty">
          <div className="text-4xl mb-2">📭</div>Nessun log ancora.
        </div>
      ) : (
        <div className="border border-slate-800 rounded-lg bg-slate-900" data-testid="log-list">
          <ul className="divide-y divide-slate-800">
            {logs.map(l => (
              <li key={l.log_id} className="p-3 hover:bg-slate-800/40 flex items-start gap-3 text-sm">
                <div className="text-xl leading-none">{emojiFor(l.action)}</div>
                <div className="flex-1 min-w-0">
                  <div className="font-mono text-emerald-300 text-xs">{l.action}</div>
                  {Object.keys(l.meta || {}).length > 0 && (
                    <div className="text-xs text-slate-400 mt-0.5 font-mono truncate">{JSON.stringify(l.meta)}</div>
                  )}
                </div>
                <div className="text-[10px] text-slate-500 shrink-0 font-mono">
                  {new Date(l.created_at).toLocaleString("it-IT", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" })}
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
